
import * as Constants from './Constants';

const initialState = null;

function registrationInfo(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return { ...state, title: action.response && action.response.data };
    default:
      return state;
  }
}


export default registrationInfo;
